import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};
const _hoisted_2 = ["onClick"];
import * as pathToRegexp from 'path-to-regexp';

import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {
    const levelList = ref([]);
    const route = useRoute();
    const router = useRouter();
    getBreadcrumb();
    watch(route, () => {
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      getBreadcrumb();
    });
    function getBreadcrumb() {
      // only show routes with meta.title
      let matched = route.matched.filter(item => item.meta && item.meta.title);
      const first = matched[0];
      if (!isHome(first)) {
        matched.unshift({
          path: '/home',
          meta: {
            title: '主页'
          },
          name: ''
        });
      }
      levelList.value = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
    }
    function isHome(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase();
    }
    function pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const {
        params
      } = route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    }
    function handleLink(item) {
      const {
        redirect,
        path
      } = item;
      if (redirect) {
        router.push(redirect);
        return;
      }
      router.push(pathCompile(path));
    }
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "app-breadcrumb",
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_TransitionGroup, {
          name: "breadcrumb"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(levelList), (item, index) => {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withCtx(() => [item.redirect === 'noRedirect' || index == _unref(levelList).length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1)) : (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _withModifiers($event => handleLink(item), ["prevent"])
              }, _toDisplayString(item.meta.title), 9, _hoisted_2))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});